import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CregresivaService {

  value = `18 de marzo, 19 hrs.`;
  valor:any = this.cuentaRegresiva(1,1);

  constructor() {
  }

  public cuentaRegresiva( valor1:number, valor2:number ):any {
    return valor1+valor2;
  }

  updateCountdown() {
    console.log(`sin chiste alguno ${ Date() }`);
    new Date();
    return;
  }
}
